import { useMutation } from '@tanstack/react-query';
import api from 'services/api/api';

export const getActivityById = async (id: number) => {
	const response = await api.get(`atividade/atividadeById?id=${id}`);
	return response.data;
};
export const useGetActivityById = (setForm, id) => {
	return useMutation(() => getActivityById(id), {
		onSuccess: data => {
			setForm({
				descricao: data.descricao,
				grupo_recurso_id: data.grupo_recurso_id,
				id: data.id,
			});
		},
	});
};
